"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _arrayIntersection = _interopRequireDefault(require("../core/utilities/arrayIntersection"));

var availableCurrenciesAdapter = function availableCurrenciesAdapter(productData, _ref) {
  var itemConfigurations = _ref.itemConfigurations;
  var products = productData.products,
      customerCurrencyCode = productData.customerCurrencyCode; // Customer currency code exists when a user has already purchased
  // one of our products in apollo. We want to lock them into that
  // curerncy and therefore we only return that value.

  if (customerCurrencyCode) {
    return [customerCurrencyCode];
  }

  var _getAvailableCurrencies = function _getAvailableCurrencies(_ref2) {
    var merchandiseId = _ref2.merchandiseId;
    var product = products[merchandiseId];

    if (!product) {
      return [];
    }

    if (product.pricingWrap.pricingType === 'TIERED') {
      return (product.pricingWrap.tieredPrices || []).map(function (el) {
        return el.currencyCode;
      });
    }

    return (product.pricingWrap.prices || []).map(function (el) {
      return el.currencyCode;
    });
  };

  return _arrayIntersection.default.apply(void 0, (0, _toConsumableArray2.default)(itemConfigurations.map(_getAvailableCurrencies)));
};

var _default = availableCurrenciesAdapter;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/adapters/availableCurrenciesAdapter.js
// module id = 418
// module chunks = 5 6 7